export default "__VITE_ASSET__W4hNCk_y__"